export default function (element, data) {
    const block = element.querySelector(".group"); // Блок текста
    const text = element.querySelector(".group-image"); // Блок текста
    const mobileText = element.querySelector(".mobile-text .text");

    //start(); // Запуск

    window.addEventListener("slidefourstart", start); // Слушатель события
    window.addEventListener("slidefourreset", reset); // Слушатель события

    function start(event) {

        if(element.classList.contains("active")) {
            window.dispatchEvent(new CustomEvent("mobiletextupdate", {detail: {text: mobileText.innerText}}));
            text.querySelector(".cloud-mobile").classList.add("show");
        }
        setTimeout(function() {
            block.classList.add("active");
            text.classList.add("active");
        }, 500);

        // Эффект FADE после таймаута
        let fadeTimeout = event.detail - 500;
        setTimeout(function() {
            block.classList.remove("active");
        }, fadeTimeout);
    }

    // Сброс анимации
    function reset() {
        text.classList.remove("active");
        text.querySelector(".cloud-mobile").classList.remove("show");
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
